import waRequest from './wa-request';

export const baseApi = process.env.REACT_APP_ENVIRONMENT?.startsWith('DEV') ? '/document360/v1' : '/zendesk/v1';

function getZendeskHelpUrl() {
  const url = `${baseApi}/get-url`;

  return waRequest.requestAuthenticated({url: url, method: 'get'});
}

export default {
  getZendeskHelpUrl,
};
